import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';
import { TaskComponent } from '../task/task.component';
import { Task } from '../../task';

@Component({
    selector: 'app-task-summary',
    templateUrl: './task-summary.component.html',
    styleUrls: ['./task-summary.component.css'],
    standalone: false
})
export class TaskSummaryComponent extends TaskComponent implements OnInit, AfterViewInit
{

	@Input() task: Task;

	taskApi;

	ngOnInit()
	{
		this.taskApi = this.task;
	}
	ngAfterViewInit()
	{
	}
}
